import { Button, Card, Col, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EducationPageChrome from '@/pages/education/components/EducationPageChrome';

const { Paragraph } = Typography;

export default function LibraryHubPage() {
  const { t } = useTranslation('education');
  const navigate = useNavigate();
  const cards = [
    { path: '/education/library/titles', title: t('libraryTitles'), desc: t('libraryTitlesIntro') },
    {
      path: '/education/library/reservations',
      title: t('libraryReservations'),
      desc: t('libraryReservationsIntro'),
    },
    { path: '/education/library/issue', title: t('libraryIssue'), desc: t('libraryIssueIntro') },
    { path: '/education/library/loans', title: t('libraryLoans'), desc: t('libraryLoansIntro') },
    {
      path: '/education/library/settings',
      title: t('librarySettings'),
      desc: t('librarySettingsIntro'),
    },
  ];
  return (
    <EducationPageChrome title={t('library')} description={t('libraryIntro')}>
      <Row gutter={[16, 16]}>
        {cards.map((card) => (
          <Col xs={24} md={8} key={card.path}>
            <Card size="small" title={card.title}>
              <Paragraph type="secondary">{card.desc}</Paragraph>
              <Button type="primary" onClick={() => navigate(card.path)}>
                {t('open')}
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </EducationPageChrome>
  );
}
